var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8973 12C23.8973 18.4285 18.8067 23.625 12.5453 23.625C6.28389 23.625 1.19336 18.4285 1.19336 12C1.19336 5.57151 6.28389 0.375 12.5453 0.375C18.8067 0.375 23.8973 5.57151 23.8973 12Z",
    fill: "white",
    stroke: "#19B3B5",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18555 13.9095V15.9214H10.1975L16.1311 9.98791L14.1191 7.97324L8.18555 13.9095ZM17.6867 8.43043C17.786 8.32961 17.8417 8.19379 17.8417 8.05228C17.8417 7.91078 17.786 7.77496 17.6867 7.67414L16.4293 6.41666C16.3284 6.31737 16.1926 6.26172 16.0511 6.26172C15.9096 6.26172 15.7738 6.31737 15.673 6.41666L14.693 7.40199L16.705 9.41037L17.6867 8.43043Z",
    fill: "#29BCC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPre);
export default __webpack_public_path__ + "static/media/EditPre.64aa385458cf05e309ba05818144863d.svg";
export { ForwardRef as ReactComponent };